function Impressum() {
    return (
        <div style={{textAlign: "center"}}>
            <h2>Angaben gemäß § 5 TMG</h2>

            Tobias Franz<br/>
            Clara-Zetkin-Str. 2<br/>
            14770  Brandenburg an der Havel<br/>

            Kontakt:<br/>
            E-Mail: tobias.franz@posteo.de
            <br />
            <br />
            <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</h2>
            Tobias Franz<br/>
            Clara-Zetkin-Str. 2<br/>
            14770  Brandenburg an der Havel<br/>
            <br />
            <br />
            <h2> Haftung für Inhalte</h2>
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
            Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
            Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            <br />
            <br />
            <h2>Haftung für Links</h2>
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
            Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
            Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            <br />
            <br />
            <h2>Hinweis zu Bewertungen</h2>
            Alle auf dieser Website veröffentlichten Bewertungen, Meinungen und Einschätzungen stellen ausschließlich die subjektive, persönliche Meinung der Autoren dar. Sie erheben keinen Anspruch auf Vollständigkeit oder Objektivität und sind nicht als Tatsachenbehauptungen zu verstehen. Die Bewertungen dienen rein informativen Zwecken und begründen keine geschäftsschädigende Absicht gegenüber den genannten Betrieben.
            <br />
            <br />
            <h2>Urheberrecht</h2>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht.
            Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet.
            Insbesondere werden Inhalte Dritter als solche gekennzeichnet.
            Solltest du trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis.
            Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
        </div>


    )
}

export default Impressum;